import * as Sentry from "@sentry/react";
import { useEffect } from "react";
Sentry.init({
  dsn: "https://89e5155ff37e1dc66970b2b9d76ce4ce@o29845.ingest.us.sentry.io/4507645801529344",
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["localhost"],
  environment: import.meta.env.MODE,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
